import Button from "@/components/Button";
import Dialog from "@/components/Dialog";
import classNames from "classnames";
import { JobActionType, JOB_ACTION_CONFIGS } from "@/pages/_layouts/jobs/types";

export interface JobActionModalProps {
  disabled: boolean;
  open: boolean;
  setOpen: (value: boolean) => void;
  handleAction: () => void;
  actionType: JobActionType;
}

export default function JobActionModal({ disabled, open, setOpen, handleAction, actionType }: JobActionModalProps) {
  const config = JOB_ACTION_CONFIGS[actionType];
  const { headline, buttonText, icon, modalMessage } = config;

  const handleClose = () => setOpen(false);

  return (
    <Dialog
      open={open}
      onClosed={handleClose}
      headline={headline}
      className="w-[520px] p-6 pr-2 max-h-[80vh]"
      actions={
        <>
          <Button variant="text" onClick={handleClose} disabled={disabled}>
            Cancel
          </Button>

          <Button
            trailingIcon={false}
            icon={disabled ? "progress_activity" : icon}
            iconClassName={classNames(disabled && "animate-spin w-6 h-6 !block")}
            onClick={handleAction}
            disabled={disabled}
          >
            {buttonText}
          </Button>
        </>
      }
    >
      <div className="overflow-auto -mt-2 space-y-6">
        <div>{modalMessage}</div>
      </div>
    </Dialog>
  );
}
